import {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import ImageInput from '../AgentOnboard/ImageInput';
import DateTimePickerInput from '../DateTimePickerInput';

class ModalFormPartial extends Component {
    static get propTypes() {
        return {
            transactions: PropTypes.object,
            transactionToEdit: PropTypes.object,
            visible: PropTypes.boolean,
            denormalizePrice: PropTypes.function,
            onClose: PropTypes.function,
            onSave: PropTypes.function
        };
    }

    state = {
        propertyImage: '',
        address: '',
        zip: '',
        beds: '',
        baths: '',
        finishedSqFt: '',
        soldPrice: '',
        soldDate: '',
        buy: '',
        isLoadingData: false
    };

    autoComplete;
    addressInputRef;

    cleanListeners = () => {
        google.maps.event.clearInstanceListeners(this.autoComplete);
        this.autoComplete = null;
    };

    componentDidUpdate(prevProps) {
        if (prevProps.visible && !this.props.visible) {
            this.setState({
                txId: '',
                propertyImage: '',
                address: '',
                zip: '',
                beds: '',
                baths: '',
                finishedSqFt: '',
                soldPrice: '',
                soldDate: '',
                isLoadingData: false
            });
        } else if (!prevProps.visible && this.props.visible) {
            const {transactionToEdit, transactions} = this.props;
            if (transactionToEdit) {
                this.setState(state => ({
                    ...state,
                    ...transactions[transactionToEdit]
                }));
            }
            this.initGoogleAutoComplete(this.addressInputRef);
        }
    }

    initGoogleAutoComplete = ref => {
        if (!ref && this.googleListeners && this.autoComplete) {
            return;
        }

        this.autoComplete = new google.maps.places.Autocomplete(ref, {
            types: ['address'],
            componentRestrictions: {country: 'us'}
        });

        this.autoComplete.addListener('place_changed', () => {
            const {formatted_address, address_components} = this.autoComplete.getPlace();
            const address = (formatted_address || '').replace(/\s*[0-9]+,?\s+(USA|United States)$/, '');

            this.setState({
                address,
                zip: getPlaceAddressComponentByType(address_components, 'postal_code')
            });
        });
    };

    renderModalForm = () => {
        const {
            address,
            zip,
            beds,
            baths,
            finishedSqFt,
            soldPrice,
            soldDate,
            buy,
            isLoadingData,
            featured,
            photoUrl,
            propertyImage: currentPropertyImage
        } = this.state;
        const {imageIcon, onDelete, denormalizePrice, featuredTransactionsCount} = this.props;
        const hasImage = !!photoUrl || !!currentPropertyImage?.src;

        return (
            <div className="modal-form">
                <div className="row">
                    <div className="col-xs-12">
                        <label htmlFor="addressModal">Property Address</label>
                        <input
                            value={address || ''}
                            ref={el => (this.addressInputRef = el)}
                            name="addressModal"
                            type="text"
                            className="transaction-input"
                            placeholder="Full Property Address"
                            onBlur={this.handleAddressInput}
                            onChange={({target: {value}}) => this.setState({address: value})}
                            onKeyDown={e => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                </div>
                {isLoadingData && (
                    <div className="loading">
                        <i className="icon-nav-sync loading-icon" /> <span> Loading property information</span>
                    </div>
                )}

                {!isLoadingData && (
                    <div className="row">
                        <div className="col-xs-4">
                            <label htmlFor="buyModal">Type</label>
                            <select
                                defaultValue={typeof buy !== 'undefined' ? '' + buy : ''}
                                name="buyModal"
                                type="number"
                                className="transaction-input"
                                placeholder="000000"
                                onChange={({target: {value}}) => this.setState({buy: value === 'true'})}>
                                <option value="false">Sold</option>
                                <option value="true">Bought</option>
                            </select>
                        </div>
                        <div className="col-xs-4">
                            <label htmlFor="soldDateModal">Sold Date</label>
                            <DateTimePickerInput
                                options={{
                                    date: soldDate || null,
                                    maxDate: new Date()
                                }}
                                defaultValue={soldDate || null}
                                name="soldDateModal"
                                className="transaction-input"
                                autoComplete="off"
                                onChange={({target: {value}}) => {
                                    this.setState({soldDate: value});
                                }}
                            />
                        </div>
                        <div className="col-xs-4 compact-field listprice">
                            <label htmlFor="listPriceModal">Sales Price</label>
                            <input
                                value={soldPrice ? denormalizePrice(soldPrice) : ''}
                                name="listPriceModal"
                                className="transaction-input"
                                placeholder="0"
                                onKeyUp={({target: {value}}) =>
                                    this.setState({
                                        soldPrice: denormalizePrice(value)
                                    })
                                }
                            />
                        </div>
                    </div>
                )}
                {!isLoadingData && (
                    <div className="row compact-row">
                        <div className="col-xs-4">
                            <label htmlFor="zipModal">Zipcode</label>
                            <input
                                value={zip || ''}
                                name="zipModal"
                                type="text"
                                className="transaction-input"
                                placeholder="000000"
                                onChange={({target: {value}}) => this.setState({zip: value.replace(/\D+/g, '')})}
                            />
                        </div>
                        <div className="col-xs-2 compact-field">
                            <label htmlFor="bedsModal">Beds</label>
                            <input
                                value={beds || ''}
                                name="bedsModal"
                                type="text"
                                className="transaction-input"
                                onChange={({target: {value}}) => this.setState({beds: value.replace(/\D+/g, '')})}
                            />
                        </div>
                        <div className="col-xs-2 compact-field">
                            <label htmlFor="bathsModal">Bath</label>
                            <input
                                value={baths || ''}
                                name="bathsModal"
                                type="text"
                                className="transaction-input"
                                onChange={({target: {value}}) => this.setState({baths: value.replace(/\D+\./g, '')})}
                            />
                        </div>
                        <div className="col-xs-4 compact-field">
                            <label htmlFor="finishedSqFtModal ">Sq. Ft</label>
                            <input
                                value={finishedSqFt || ''}
                                name="finishedSqFtModal"
                                type="text"
                                className="transaction-input"
                                onChange={({target: {value}}) =>
                                    this.setState({finishedSqFt: value.replace(/\D+\,/g, '')})
                                }
                            />
                        </div>
                    </div>
                )}
                <div className="image-input-row">
                    <label>Property Image</label>
                    <ImageInput
                        onChange={propertyImage => this.setState({propertyImage, uploading: false})}
                        onUploading={uploading => this.setState(uploading)}>
                        <div className={`property-image${hasImage ? ' has-image' : ''}`}>
                            {hasImage ? (
                                <div
                                    className={`property-image${hasImage ? ' has-image' : ''}`}
                                    style={
                                        hasImage
                                            ? `background-image: url(${currentPropertyImage?.src || photoUrl})`
                                            : ''
                                    }></div>
                            ) : (
                                <div className="image-placeholder">{imageIcon}</div>
                            )}
                        </div>
                    </ImageInput>
                </div>
                <div className="image-input-row featured-row">
                    <label>Feature on profile?</label>

                    <div
                        className={`switch-inpunt-wrapper${featured ? ' active' : ''}`}
                        onClick={() => {
                            if (featuredTransactionsCount >= 10 && !featured) {
                                return;
                            }
                            this.setState({featured: !featured});
                        }}>
                        <span className="switch-input-dot"></span>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const {transactionToEdit, visible, onClose, onSave, onDelete, currentPage} = this.props;
        const {address, txId, uploading} = this.state;
        const canBeDeleted = currentPage == 1 ? (transactionToEdit || '_').split('_')[1] > 2 : true;

        if (!visible) {
            return null;
        }

        return (
            <div className="modal modal-visible" tabindex="-1" role="dialog">
                <div
                    className="modal-closer"
                    onClick={() => {
                        this.cleanListeners();
                        onClose();
                    }}></div>
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body">{this.renderModalForm()}</div>
                        <div className="modal-footer action-buttons-container">
                            <button
                                disabled={uploading}
                                onClick={() => {
                                    if (!canBeDeleted) {
                                        return;
                                    }
                                    onDelete();
                                }}
                                type="button"
                                className={`remove-transaction${canBeDeleted ? '' : ' disabled'}`}>
                                <i className="icon-delete delete-button" />
                            </button>
                            {uploading ? (
                                <div className="submit-button disabled">
                                    <i className="icon-settings-outline loading-icon saving" /> Uploading Image...
                                </div>
                            ) : (
                                <button
                                    type="button"
                                    className="submit-button"
                                    disabled={uploading}
                                    onClick={() => {
                                        this.cleanListeners();
                                        onSave({
                                            tx: transactionToEdit,
                                            ...this.state
                                        });
                                    }}>
                                    {!!txId && !!address ? 'Save Changes' : 'Add Transaction'}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalFormPartial;
